import React, { useMemo } from 'react';
import PrimaryStage from 'commonComponents/Stages/PrimaryStage/PrimaryStage';
import TextWithImages from 'commonComponents/sections/TextWithImages/TextWithImages';
import BaseSectionWithImage from 'commonComponents/sections/BaseSectionWithImage/BaseSectionWithImage';
import Consultants from 'commonComponents/Consultants/Consultants';
import Transfer from './Transfer/Transfer';
import { house } from './images';
import styles from '../pages.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const PropertyTransactionProcessPage = ({
  locale,
  banner,
  firstSection,
  concept,
  experts,
  transfer,
  salesFunnelLink,
  funnelLink
}) => {
  const context = require.context('oldAssets/images/static_pages/property_transaction_process', 
    false, /ssp_photo_\d\.webp$/);

  const conceptProps = useMemo(() => {
    return {
      ...concept,
      anchor: 'concept',
      image: house(locale)
    };
  }, [concept, locale]);

  const firstSectionProps = { ...firstSection, anchor: 'sell-your-property-now' };

  conceptProps.button.link = funnelLink;

  const { name, position } = experts;
  const consultants = [
    { name: 'Andre Torkler' },
    { name, position, isPrimary: true },
    { name: 'Hofmann Anton' }
  ];

  return (
    <div className={ styles.Page }>
      <PrimaryStage { ...banner } pageName="salesProcess" />
      <TextWithImages { ...firstSectionProps } context={ context } />
      <BaseSectionWithImage { ...conceptProps } />
      <Transfer { ...transfer } />
      <section></section>
      <Consultants { ...experts }
        consultants={ consultants }
        link={ salesFunnelLink }
        type="short"
      />
    </div>
  );
};

export default PropertyTransactionProcessPage;
